import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/sign-homepage-logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-012b5502")

_pushScopeId("data-v-012b5502")
const _hoisted_1 = { class: "login-page login-page-form" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  alt: "华耐设计云平台 LOGO",
  class: "SignFlowHomepage-logo",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "mb-3 password-input" }
const _hoisted_5 = /*#__PURE__*/_createVNode("button", {
  type: "submit",
  class: "btn btn-primary btn-block btn-large"
}, "登录", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "open-tips" }, "申请开通：400-600-2222", -1)
const _hoisted_7 = {
  key: 0,
  class: "reset-psw-pop"
}
const _hoisted_8 = { class: "login-page login-page-form" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "page-title" }, "修改密码", -1)
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = { class: "mb-2" }
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = { class: "mb-2" }
const _hoisted_14 = /*#__PURE__*/_createVNode("button", {
  type: "submit",
  class: "btn btn-primary btn-block btn-large"
}, "提交", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_validate_input = _resolveComponent("validate-input")!
  const _component_validate_form = _resolveComponent("validate-form")!

  return (_openBlock(), _createBlock("div", {
    class: "SignFlowHomepage",
    style: _ctx.indexBgUrl?{backgroundImage: 'url('+(_ctx.indexBgUrl)+')'}:''
  }, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_validate_form, { onFormSubmit: _ctx.onFormSubmit }, {
        submit: _withId(() => [
          _hoisted_5
        ]),
        default: _withId(() => [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_validate_input, {
              rules: _ctx.accountRules,
              modelValue: _ctx.accountVal,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.accountVal = $event)),
              placeholder: "请输入账号",
              type: "text",
              ref: "inputRef"
            }, null, 8, ["rules", "modelValue"])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_validate_input, {
              type: _ctx.openPsw?'text':'password',
              placeholder: "请输入密码",
              rules: _ctx.passwordRules,
              modelValue: _ctx.passwordVal,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.passwordVal = $event))
            }, null, 8, ["type", "rules", "modelValue"]),
            _createVNode("div", {
              class: ["eye-btn", _ctx.openPsw?'open':''],
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openPsw=!_ctx.openPsw))
            }, null, 2)
          ]),
          _createVNode("div", {
            class: "reset-psw-btn",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetParams.isShow=true))
          }, "修改密码")
        ]),
        _: 1
      }, 8, ["onFormSubmit"]),
      _hoisted_6
    ]),
    (_ctx.resetParams.isShow)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode("div", {
            class: "mask",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetParams.isShow=_ctx.flase))
          }),
          _createVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_validate_form, { onFormSubmit: _ctx.handleReset }, {
              submit: _withId(() => [
                _hoisted_14
              ]),
              default: _withId(() => [
                _createVNode("div", _hoisted_10, [
                  _createVNode(_component_validate_input, {
                    rules: _ctx.accountRules,
                    modelValue: _ctx.resetParams.accountVal,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.resetParams.accountVal = $event)),
                    placeholder: "请输入账号",
                    type: "text",
                    ref: "inputRef"
                  }, null, 8, ["rules", "modelValue"])
                ]),
                _createVNode("div", _hoisted_11, [
                  _createVNode(_component_validate_input, {
                    type: "password",
                    placeholder: "请输入原密码",
                    rules: _ctx.passwordRules,
                    modelValue: _ctx.resetParams.passwordVal,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.resetParams.passwordVal = $event))
                  }, null, 8, ["rules", "modelValue"])
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode(_component_validate_input, {
                    type: "password",
                    placeholder: "请输入新密码",
                    rules: _ctx.passwordRules,
                    modelValue: _ctx.resetParams.newPasswordVal,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.resetParams.newPasswordVal = $event))
                  }, null, 8, ["rules", "modelValue"])
                ]),
                _createVNode("div", _hoisted_13, [
                  _createVNode(_component_validate_input, {
                    type: "password",
                    placeholder: "请再次输入新密码",
                    rules: _ctx.passwordRules,
                    modelValue: _ctx.resetParams.newPassword2Val,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.resetParams.newPassword2Val = $event))
                  }, null, 8, ["rules", "modelValue"])
                ])
              ]),
              _: 1
            }, 8, ["onFormSubmit"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 4))
})